// DS: MO3.4.3
import React from 'react';
import DeviationShopCard from '../DeviationShopCard';
import { Props as DeviationShopCardProps } from '../DeviationShopCard/DeviationShopCard';
import AdoptableCardStats from './_partials/AdoptableCardStats';
import AdoptableDetailsRightSide from './_partials/AdoptableDetailsRightSide';

export interface Props extends Pick<
  DeviationShopCardProps,
  | 'detailsRightSlot'
  | 'footerSlot'
  | 'allowedIndicators'
  | 'withAuthorDetails'
  | 'withOwnerDetails'
  | 'deviation'
  | 'width'
  | 'overrideHref'
> {
  hidePrice?: boolean;
  hideSold?: boolean;
}

const AdoptableShopCard: React.FC<Props> = ({
  deviation,
  allowedIndicators,
  hidePrice,
  hideSold,
  ...deviationShopCardProps
}) => {
  return (
    <DeviationShopCard
      deviation={deviation}
      noCentsOnPrice
      withStats
      withDescriptionBlock={false}
      allowedIndicators={allowedIndicators}
      belowCoverImageRightSlot={<AdoptableCardStats deviation={deviation} />}
      detailsRightSlot={
        <AdoptableDetailsRightSide
          deviation={deviation}
          hideSold={hideSold}
          hidePrice={hidePrice}
        />
      }
      {...deviationShopCardProps}
    />
  );
};
AdoptableShopCard.displayName = 'AdoptableShopCard';

export default AdoptableShopCard;
